<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-chip
        small
        :color="chip.colour"
        :class="{ strikethrough: chip.strikeThrough, 'lighten-4': disabled }"
        v-on="on"
      >
        {{ truncatedProduct }}
      </v-chip>
    </template>
    <span>{{ product }}</span>
  </v-tooltip>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'enquiry-status-chip',
  props: ['product', 'status', 'disabled'],
  data: () => ({
    chipColours: [
      { status: 'ENQUIRY ACCEPTED', colour: 'light-blue', textColour: 'grey lighten-5', strikeThrough: false },
      { status: 'FUNDER OFFER MADE', colour: 'green', textColour: 'grey lighten-5', strikeThrough: false },
      { status: 'FUNDER OFFER ACCEPTED', colour: 'green', textColour: 'grey lighten-5', strikeThrough: false },
      { status: 'SME OFFER ACCEPTED', colour: 'green', textColour: 'grey lighten-5', strikeThrough: false },
      { status: 'FUNDING RELEASED', colour: 'green', textColour: 'grey lighten-5', strikeThrough: false },
      { status: 'ENQUIRY REJECTED', colour: 'red', textColour: 'grey lighten-5', strikeThrough: false },
      { status: 'FUNDER DECLINED TO OFFER', colour: 'red', textColour: 'grey lighten-5', strikeThrough: false },
      { status: 'SME OFFER REJECTED', colour: 'red', textColour: 'grey lighten-5', strikeThrough: false },
      { status: 'SME CANCELLED', colour: 'red', textColour: 'grey lighten-5', strikeThrough: false },
      { status: 'PENDING', colour: 'light-grey', textColour: 'grey darken-4', strikeThrough: false },
      { status: 'EXPIRED', colour: 'light-grey', textColour: 'grey darken-1', strikeThrough: true }
    ]
  }),
  computed: {
    chip() {
      let chip = _.find(this.chipColours, ['status', this.status]);
      if (_.isUndefined(chip)) {
        chip = { colour: 'light-grey', textColour: 'black' };
      }
      return chip;
    },
    truncatedProduct() {
      return _.truncate(this.product, {
        length: 10,
        omission: '...'
      });
    }
  }
};
</script>

<style scoped>
.strikethrough {
  text-decoration: line-through;
}
</style>
